import { createContext } from "react";
export var ServiceWorkerContext = createContext({
  updateAvailable: false
});